export const MapPin = (props?: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 6.66663C14 11.3333 8 15.3333 8 15.3333C8 15.3333 2 11.3333 2 6.66663C2 5.07533 2.63214 3.5492 3.75736 2.42399C4.88258 1.29877 6.4087 0.666626 8 0.666626C9.5913 0.666626 11.1174 1.29877 12.2426 2.42399C13.3679 3.5492 14 5.07533 14 6.66663Z"
        stroke={props?.stroke || "#C74601"}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 8.66663C9.10457 8.66663 10 7.7712 10 6.66663C10 5.56206 9.10457 4.66663 8 4.66663C6.89543 4.66663 6 5.56206 6 6.66663C6 7.7712 6.89543 8.66663 8 8.66663Z"
        stroke={props?.stroke || "#C74601"}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Phone = (props?: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3833_4207)">
        <path
          d="M14.6666 11.28V13.28C14.6674 13.4657 14.6294 13.6494 14.555 13.8195C14.4806 13.9897 14.3715 14.1424 14.2347 14.2679C14.0979 14.3934 13.9364 14.489 13.7605 14.5485C13.5846 14.6079 13.3982 14.63 13.2133 14.6133C11.1619 14.3904 9.19131 13.6894 7.45998 12.5667C5.84919 11.5431 4.48353 10.1774 3.45998 8.56665C2.33329 6.82745 1.63214 4.84731 1.41331 2.78665C1.39665 2.60229 1.41856 2.41649 1.47764 2.24107C1.53673 2.06564 1.63169 1.90444 1.75649 1.76773C1.88128 1.63102 2.03318 1.52179 2.2025 1.447C2.37183 1.37221 2.55487 1.33349 2.73998 1.33332H4.73998C5.06351 1.33013 5.37717 1.4447 5.62248 1.65567C5.8678 1.86664 6.02803 2.15961 6.07331 2.47998C6.15772 3.12003 6.31428 3.74847 6.53998 4.35332C6.62967 4.59193 6.64908 4.85126 6.59591 5.10057C6.54274 5.34988 6.41922 5.57872 6.23998 5.75998L5.39331 6.60665C6.34235 8.27568 7.72428 9.65761 9.39331 10.6067L10.24 9.75998C10.4212 9.58074 10.6501 9.45722 10.8994 9.40405C11.1487 9.35088 11.408 9.37029 11.6466 9.45998C12.2515 9.68568 12.8799 9.84224 13.52 9.92665C13.8438 9.97234 14.1396 10.1355 14.351 10.385C14.5624 10.6345 14.6748 10.953 14.6666 11.28Z"
          stroke={props?.stroke || "#C74601"}
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3833_4207">
          <rect
            width="16"
            height="16"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Mail = (props?: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      className="shrink-0"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M2.66732 2.66675H13.334C14.0673 2.66675 14.6673 3.26675 14.6673 4.00008V12.0001C14.6673 12.7334 14.0673 13.3334 13.334 13.3334H2.66732C1.93398 13.3334 1.33398 12.7334 1.33398 12.0001V4.00008C1.33398 3.26675 1.93398 2.66675 2.66732 2.66675Z"
        stroke={props?.stroke || "#C74601"}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6673 4L8.00065 8.66667L1.33398 4"
        stroke={props?.stroke || "#C74601"}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Clock = (props?: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3267_5052)">
        <path
          d="M7.99967 14.6668C11.6816 14.6668 14.6663 11.6821 14.6663 8.00016C14.6663 4.31826 11.6816 1.3335 7.99967 1.3335C4.31778 1.3335 1.33301 4.31826 1.33301 8.00016C1.33301 11.6821 4.31778 14.6668 7.99967 14.6668Z"
          stroke={props?.stroke || "#C74601"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 4V8L10.6667 9.33333"
          stroke={props?.stroke || "#C74601"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3267_5052">
          <rect
            width="16"
            height="16"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const StaffingIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="82"
    height="82"
    viewBox="0 0 82 82"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M41 81C63.0914 81 81 63.0914 81 41C81 18.9086 63.0914 1 41 1C18.9086 1 1 18.9086 1 41C1 63.0914 18.9086 81 41 81Z"
      stroke="url(#paint0_linear_3882_990)"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M43.6752 48.634H38.3755V57.0883H43.6752V48.634Z"
      stroke="#06A6AB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.2555 24.7855H29.795C28.7496 24.7855 27.9022 25.6329 27.9022 26.6782C27.9022 27.7235 28.7496 28.571 29.795 28.571H52.2555C53.3009 28.571 54.1483 27.7235 54.1483 26.6782C54.1483 25.6329 53.3009 24.7855 52.2555 24.7855Z"
      stroke="#00797D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.183 28.5709H30.8676V57.2145H51.183V28.5709Z"
      stroke="#00797D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.0253 43.4605C44.3704 43.4605 47.0821 40.7488 47.0821 37.4038C47.0821 34.0587 44.3704 31.347 41.0253 31.347C37.6802 31.347 34.9685 34.0587 34.9685 37.4038C34.9685 40.7488 37.6802 43.4605 41.0253 43.4605Z"
      stroke="#06A6AB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.1546 35.1199V36.8864H38.3502V38.5647H40.1546V40.1167H42.0852V38.5394H43.6878V36.8738H42.0474V35.1199H40.1546Z"
      stroke="#06A6AB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.9559 57.2145H65.8328V32.8611H54.9054"
      stroke="#00797D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.0947 57.0883H16.1672V32.735H27.1452"
      stroke="#00797D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.4669 35.1324H18.4385V38.1608H21.4669V35.1324Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.7666 35.1324H23.7382V38.1608H26.7666V35.1324Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.4669 39.9274H18.4385V42.9558H21.4669V39.9274Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.7666 39.9274H23.7382V42.9558H26.7666V39.9274Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.4669 44.7224H18.4385V47.7507H21.4669V44.7224Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.7666 44.7224H23.7382V47.7507H26.7666V44.7224Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.4669 49.5173H18.4385V52.5457H21.4669V49.5173Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.7666 49.5173H23.7382V52.5457H26.7666V49.5173Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.3123 35.3848H55.2839V38.4132H58.3123V35.3848Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.612 35.3848H60.5836V38.4132H63.612V35.3848Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.3123 40.1798H55.2839V43.2082H58.3123V40.1798Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.612 40.1798H60.5836V43.2082H63.612V40.1798Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.3123 44.9747H55.2839V48.0031H58.3123V44.9747Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.612 44.9747H60.5836V48.0031H63.612V44.9747Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.3123 49.7697H55.2839V52.7981H58.3123V49.7697Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.612 49.7697H60.5836V52.7981H63.612V49.7697Z"
      stroke="#00797D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3882_990"
        x1="-0.135647"
        y1="41"
        x2="82.1356"
        y2="41"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E56E2E" />
        <stop
          offset="1"
          stopColor="#FFD5BF"
        />
      </linearGradient>
    </defs>
  </svg>
);

export const Menu: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.2002 4.80005H22.8002"
        stroke="#474544"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.2002 12H22.8002"
        stroke="#474544"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.2002 19.2H22.8002"
        stroke="#474544"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const X: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_41_23862)">
        <path
          d="M22.2858 1.71436L1.71436 22.2858"
          stroke="#474544"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.71436 1.71436L22.2858 22.2858"
          stroke="#474544"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_41_23862">
          <rect
            width="24"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ServicesForFamiliesIcon: React.FC<
  React.SVGProps<SVGSVGElement>
> = (props) => {
  return (
    <svg
      width="82"
      height="82"
      viewBox="0 0 82 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M41.0566 49.0154C43.5844 49.0154 45.6336 46.9662 45.6336 44.4384C45.6336 41.9106 43.5844 39.8615 41.0566 39.8615C38.5288 39.8615 36.4796 41.9106 36.4796 44.4384C36.4796 46.9662 38.5288 49.0154 41.0566 49.0154Z"
        stroke="#06A6AB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.7474 53.3691C37.9642 52.5988 39.4043 52.1411 40.9448 52.1411C42.4853 52.1411 43.9366 52.5876 45.1422 53.3691"
        stroke="#06A6AB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.0334 56.6733C48.4911 57.6668 48.7591 58.7832 48.7591 59.9553"
        stroke="#06A6AB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.8784 56.6064C33.3984 57.6222 33.1305 58.7609 33.1305 59.9554"
        stroke="#06A6AB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.8942 31.1539C56.422 31.1539 58.4712 29.1048 58.4712 26.577C58.4712 24.0492 56.422 22 53.8942 22C51.3664 22 49.3173 24.0492 49.3173 26.577C49.3173 29.1048 51.3664 31.1539 53.8942 31.1539Z"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.2188 31.1539C30.7466 31.1539 32.7957 29.1048 32.7957 26.577C32.7957 24.0492 30.7466 22 28.2188 22C25.691 22 23.6418 24.0492 23.6418 26.577C23.6418 29.1048 25.691 31.1539 28.2188 31.1539Z"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5013 37.8965C25.6177 35.9541 26.8903 34.8378 28.2411 34.8378C30.4068 34.8378 32.3603 37.6621 33.7781 42.2167"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4268 59.9553C20.4268 52.9559 21.3199 46.6263 22.7488 42.0828"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9813 38.1868C24.9813 38.1868 20.2034 35.6193 19.4108 30.7297C19.2768 29.9259 18.7521 29.3343 18.1382 29.3343C17.4125 29.3343 16.8209 30.1269 16.8432 31.0981C16.8879 33.5987 17.6916 38.265 22.5588 41.9489"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.4889 37.9412C56.3726 35.9988 55.0999 34.8824 53.7492 34.8824C51.5835 34.8824 49.6299 37.7068 48.2122 42.2614"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.5637 60C61.5637 53.0006 60.6706 46.671 59.2305 42.1275"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.0089 38.2316C57.0089 38.2316 61.7979 35.664 62.5905 30.7744C62.7245 29.9707 63.2492 29.379 63.8631 29.379C64.5888 29.379 65.1804 30.1716 65.1693 31.1428C65.1246 33.6434 64.3208 38.3097 59.4536 41.9936"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.6894 53.8155C45.6894 53.8155 48.3016 52.2303 50.0878 50.2655C50.0878 50.2655 50.5566 49.5287 51.0031 49.5287C51.5278 49.5287 51.952 49.953 51.9409 50.4665C51.9074 51.7949 51.6283 54.463 48.1342 56.4165"
        stroke="#06A6AB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.2003 53.8937C36.2003 53.8937 32.3713 52.9336 31.8019 50.3437C31.7126 49.9195 31.3331 49.6069 30.8865 49.6069C30.3619 49.6069 29.9377 50.0311 29.9488 50.5447C29.9823 51.8731 30.2614 54.5411 33.7555 56.4947"
        stroke="#06A6AB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41 81C63.0914 81 81 63.0914 81 41C81 18.9086 63.0914 1 41 1C18.9086 1 1 18.9086 1 41C1 63.0914 18.9086 81 41 81Z"
        stroke="url(#paint0_linear_3882_4658)"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3882_4658"
          x1="-0.135647"
          y1="41"
          x2="82.1356"
          y2="41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E56E2E" />
          <stop
            offset="1"
            stopColor="#FFD5BF"
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const ResourcesForFamilies: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="82"
      height="82"
      viewBox="0 0 82 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M49 39.5867C51.3218 39.7129 54.2114 40.3565 57.7193 41.9085L60.1798 58.1609C60.1798 58.1609 45.795 52.9874 41.0631 58.1609"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.0032 62.1357H60.1798C60.1798 62.1357 58.7918 61.4416 60.1798 58.1609"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.1136 39.6498C30.7918 39.776 27.9274 40.4196 24.4322 41.9716L21.9842 58.224C21.9842 58.224 36.3186 53.0505 41.0378 58.224"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.0978 62.1987H21.9716C21.9716 62.1987 23.3596 61.5047 21.9716 58.2239"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.0032 62.1987C44.0032 62.1987 44.4196 64.5962 41.3155 64.5962C38.9432 64.6214 37.8581 63.4101 38.1357 62.1987"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.8581 31.4732C48.4827 33.3281 45.2271 38.1987 45.2271 42.4511H37.0252C37.0252 39.082 33.4669 33.2776 32.2177 31.347C31.9275 30.8927 31.7003 30.4259 31.5489 29.9464L31.2839 29.1136C29.8833 24.7476 34.4133 20.47 40.7729 20.3186C40.8864 20.3186 41.0126 20.3186 41.1262 20.3186C41.2398 20.3186 41.3659 20.3186 41.4795 20.3186C47.8391 20.47 52.3565 24.7476 50.9685 29.1136L50.7666 29.7319C50.5773 30.3375 50.2745 30.9306 49.8581 31.4732Z"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.9622 45.6688H45.1641"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.9622 48.8234H45.1641"
        stroke="#00797D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.7003 42.4511C39.7003 42.4511 39.7256 34.9432 38.9685 34.3123C38.2114 33.6814 37.5805 35.0694 37.8328 35.448C38.0852 35.8265 43.8896 34.6909 44.3943 33.9338C44.8991 33.1767 43.0063 31.7887 42.6278 32.2934C42.2492 32.7981 42.2492 42.1357 42.2492 42.1357"
        stroke="#06A6AB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.1262 13.6183V16.3943"
        stroke="#06A6AB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5237 19.3218L29.4921 21.2902"
        stroke="#06A6AB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.6656 19.3723L52.7098 21.3281"
        stroke="#06A6AB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.2082 29.265H26.1104"
        stroke="#06A6AB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.6372 29.265H58.5394"
        stroke="#06A6AB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.429 36.2808L27.4732 38.2366"
        stroke="#06A6AB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.7098 36.2808L54.6656 38.2366"
        stroke="#06A6AB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41 81C63.0914 81 81 63.0914 81 41C81 18.9086 63.0914 1 41 1C18.9086 1 1 18.9086 1 41C1 63.0914 18.9086 81 41 81Z"
        stroke="url(#paint0_linear_3882_1804)"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3882_1804"
          x1="-0.135647"
          y1="41"
          x2="82.1356"
          y2="41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E56E2E" />
          <stop
            offset="1"
            stopColor="#FFD5BF"
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const ResourcesForProfessionals: React.FC<
  React.SVGProps<SVGSVGElement>
> = (props) => {
  return (
    <svg
      width="82"
      height="82"
      viewBox="0 0 82 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M41.9464 30.8423H29.2271C28.4188 30.8423 27.7634 31.4976 27.7634 32.306V40.3565C27.7634 41.1649 28.4188 41.8202 29.2271 41.8202H41.9464C42.7548 41.8202 43.4101 41.1649 43.4101 40.3565V32.306C43.4101 31.4976 42.7548 30.8423 41.9464 30.8423Z"
        stroke="#06A6AB"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.429 27.183H37.8833C38.6404 27.183 39.2587 27.8013 39.2587 28.5584V30.1861C39.2587 30.5521 38.9558 30.8549 38.5899 30.8549H32.7224C32.3565 30.8549 32.0536 30.5521 32.0536 30.1861V28.5584C32.0536 27.8013 32.6719 27.183 33.429 27.183Z"
        stroke="#06A6AB"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M27.7634 33.5552C27.7634 33.5552 35.082 36.8991 43.4101 33.5552"
        stroke="#06A6AB"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M36.3186 35.1325H34.8549C34.7016 35.1325 34.5773 35.2568 34.5773 35.4101V35.7382C34.5773 35.8915 34.7016 36.0158 34.8549 36.0158H36.3186C36.4719 36.0158 36.5962 35.8915 36.5962 35.7382V35.4101C36.5962 35.2568 36.4719 35.1325 36.3186 35.1325Z"
        stroke="#06A6AB"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M35.5868 50.4637C44.4024 50.4637 51.5489 43.3172 51.5489 34.5016C51.5489 25.6859 44.4024 18.5394 35.5868 18.5394C26.7711 18.5394 19.6246 25.6859 19.6246 34.5016C19.6246 43.3172 26.7711 50.4637 35.5868 50.4637Z"
        stroke="#00797D"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M45.7319 46.8297L54.9306 56.0158"
        stroke="#00797D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M53.1767 54.2744L62.3754 63.4605"
        stroke="#00797D"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M41 81C63.0914 81 81 63.0914 81 41C81 18.9086 63.0914 1 41 1C18.9086 1 1 18.9086 1 41C1 63.0914 18.9086 81 41 81Z"
        stroke="url(#paint0_linear_3882_454)"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3882_454"
          x1="-0.135647"
          y1="41"
          x2="82.1356"
          y2="41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E56E2E" />
          <stop
            offset="1"
            stopColor="#FFD5BF"
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Chevron: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M6 15L12 9L18 15"
        stroke="#121010"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalendarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="group-hover:text-secondary-500"
      {...props}
    >
      <path
        d="M10.6398 9.75997C11.008 9.75997 11.3065 9.46149 11.3065 9.0933C11.3065 8.72511 11.008 8.42664 10.6398 8.42664C10.2716 8.42664 9.97314 8.72511 9.97314 9.0933C9.97314 9.46149 10.2716 9.75997 10.6398 9.75997Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.444445"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6667 2.66663H3.33333C2.59695 2.66663 2 3.26358 2 3.99996V13.3333C2 14.0697 2.59695 14.6666 3.33333 14.6666H12.6667C13.403 14.6666 14 14.0697 14 13.3333V3.99996C14 3.26358 13.403 2.66663 12.6667 2.66663Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6665 1.33337V4.00004"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3335 1.33337V4.00004"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 6.66663H14"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="group-hover:text-secondary-500"
      {...props}
    >
      <path
        d="M9.33317 1.33337H3.99984C3.64622 1.33337 3.30708 1.47385 3.05703 1.7239C2.80698 1.97395 2.6665 2.31309 2.6665 2.66671V13.3334C2.6665 13.687 2.80698 14.0261 3.05703 14.2762C3.30708 14.5262 3.64622 14.6667 3.99984 14.6667H11.9998C12.3535 14.6667 12.6926 14.5262 12.9426 14.2762C13.1927 14.0261 13.3332 13.687 13.3332 13.3334V5.33337L9.33317 1.33337Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.3335 1.33337V5.33337H13.3335"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6668 8.66663H5.3335"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6668 11.3334H5.3335"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66683 6H6.00016H5.3335"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChatIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="group-hover:text-secondary-500"
      {...props}
    >
      <path
        d="M14.6667 7.66668C14.6694 8.54659 14.4296 9.4146 13.9667 10.2C13.418 11.1412 12.5743 11.9328 11.5303 12.4862C10.4863 13.0396 9.28315 13.3329 8.05563 13.3333C7.02906 13.3356 6.01639 13.13 5.10007 12.7333L0.666748 14L2.14452 10.2C1.68169 9.4146 1.44185 8.54659 1.44452 7.66668C1.445 6.61452 1.78722 5.58325 2.43286 4.68838C3.0785 3.79352 4.00205 3.0704 5.10007 2.60002C6.01639 2.20331 7.02906 1.99772 8.05563 2.00002H8.44451C10.0657 2.07668 11.5969 2.66319 12.7449 3.64726C13.893 4.63132 14.5773 5.94378 14.6667 7.33334V7.66668Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="4.51343"
        y="7.18005"
        width="1.33333"
        height="1.33333"
        rx="0.666667"
        fill="currentColor"
      />
      <rect
        x="7.17993"
        y="7.18005"
        width="1.33333"
        height="1.33333"
        rx="0.666667"
        fill="currentColor"
      />
      <rect
        x="9.84668"
        y="7.18005"
        width="1.33333"
        height="1.33333"
        rx="0.666667"
        fill="currentColor"
      />
    </svg>
  );
};
